var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"title"},[_vm._v("产品分类")]),_c('el-tree',{attrs:{"default-expand-all":"","data":_vm.data,"props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }